import React, { useMemo } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Onboarding from "./pages/Onboarding";
import Home from "./pages/Home";
import Search from "./pages/Search";
import MatchDetail from "./pages/MatchDetail";
import CreateMatch from "./pages/CreateMatch";
import Profile from "./pages/Profile";
import Notifications from "./pages/Notifications";
import Teams from "./pages/Teams";
import CreateTeam from "./pages/CreateTeam";
import TeamDetail from "./pages/TeamDetail";

function Loader() {
  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center">
      <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
    </div>
  );
}

function Protected({ children, requireOnboarded = true }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Handle session_id in URL fragment synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/onboarding" element={<Protected requireOnboarded={false}><Onboarding /></Protected>} />
      <Route path="/home" element={<Protected><Home /></Protected>} />
      <Route path="/search" element={<Protected><Search /></Protected>} />
      <Route path="/match/:id" element={<Protected><MatchDetail /></Protected>} />
      <Route path="/create" element={<Protected><CreateMatch /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
      <Route path="/teams" element={<Protected><Teams /></Protected>} />
      <Route path="/teams/new" element={<Protected><CreateTeam /></Protected>} />
      <Route path="/teams/:id" element={<Protected><TeamDetail /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  const toastOptions = useMemo(
    () => ({
      style: {
        background: "#18181B",
        border: "1px solid #27272A",
        color: "#FAFAFA",
      },
    }),
    []
  );
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" theme="dark" toastOptions={toastOptions} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
